let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aHS49")).then(() => parcelRequire('kSxvF'));